import React from "react";

function ContactUs() {
  return <main id="contact-us">Contact...</main>;
}

export default ContactUs;
